import { ServerSnapInfo } from '@/api/type-server'

export enum SnapshotImageStatus {
  Invalid = 0,
  OK = 1,
  GroupPermDenied = 2,
  SourceInvalid = 3,
}

export enum SnapStatus {
  Invalid = 0,
  Saving = 1,
  Aborted = 2,
  Finished = 3,
  Running = 4,
  Deleting = 5,
  Resumable = 7,
}

const snapStatusMap = {
  [SnapStatus.Invalid]: { label: 'Invalid', style: 'text-secondary' },
  [SnapStatus.Saving]: { label: 'Saving', style: 'text-warning' },
  [SnapStatus.Aborted]: { label: 'Aborted', style: 'text-secondary' },
  [SnapStatus.Finished]: { label: 'Available', style: 'text-success' },
  [SnapStatus.Running]: { label: 'Running', style: 'text-btn-secondary' },
  [SnapStatus.Deleting]: { label: 'Restorable', style: 'text-primary' },
  [SnapStatus.Resumable]: { label: 'Restorable', style: 'text-primary' },
}

export class Snapshot {
  id = 0
  resID = ''
  flagID = ''
  name = ''
  path = ''
  enabled = false
  createdAt = new Date()
  status = SnapStatus.Invalid
  imageStatus = SnapshotImageStatus.Invalid
  mismatchReason = 0
  size = 0

  constructor(props: ServerSnapInfo) {
    this.id = Number(props.id)
    this.resID = props.resID
    this.flagID = props.flag.id
    this.name = props.flag.subject
    this.path = props.path
    this.enabled = props.enabled
    this.createdAt = new Date(props.generatedTime)
    this.status = props.status
    this.imageStatus = props.imageStatus
    this.mismatchReason = props.mismatchReason
    this.size = Number(props.sizeByte)
  }

  get disabled() {
    return this.imageStatus !== SnapshotImageStatus.OK || !!this.mismatchReason
  }

  get errMsg() {
    if (this.imageStatus === SnapshotImageStatus.GroupPermDenied) {
      return 'The underlying image that this snapshot depends on belongs to the course or group. Non-members are not allowed to access it.'
    }
    if (this.imageStatus === SnapshotImageStatus.SourceInvalid) {
      return 'The image this snapshot depends on no longer exists'
    }

    const mismatchReasonMap = {
      1: 'CUDA version does not match',
      2: 'Snapshot does not match selected machine',
      3: 'GPU architecture is incompatible with this snapshot',
      4: 'Snapshot does not match selected machine',
      5: 'Snapshot does not match selected machine',
      6: 'The CPU architecture is incompatible with this snapshot',
      8: 'Snapshot need a NPU machine',
      9: 'Snapshot does not match selected machine',
      10: 'Selected machine cannot provide the disk size required for this environment',
      11: 'Snapshot status is not OK',
      12: 'The snapshot partition not match selected machine',
    }
    const mismatchReasonText =
      mismatchReasonMap[this.mismatchReason as keyof typeof mismatchReasonMap]
    if (mismatchReasonText) {
      return mismatchReasonText
    } else if (!this.enabled) {
      return 'The underlying image has expired'
    }

    return 'Unknown error'
  }

  get statusText() {
    return snapStatusMap[this.status]
  }
}
